import React from "react";
import Checkbox from "../checkbox";
import Row from "../row";
import Col from "../col";
import type { IColumnProps } from './index';

interface IColModelMenu {
  columns: IColumnProps[];
  defaultColumns: IColumnProps[];
  handleColModelMenu: (cols: any[]) => void;
}

export default (props: IColModelMenu) => {
  const { columns, defaultColumns, handleColModelMenu } = props;
  const onChange = (val) => {
    handleColModelMenu(val);
  }

  return (
    <div className="fdx-col-model-menu" style={{ background: '#fff', padding: "8px", boxShadow: "0 4px 16px 0 rgb(0 0 0 / 12%)", border: "1px solid #e0e0e0" }}>
      <Checkbox.Group value={columns?.map(opt => (opt.dataIndex || opt.key)) || []} onChange={onChange}>
        <Row type="flex" align="middle" gutter={[8, 8]}>
          {
            defaultColumns.map(col => {
              const val = col?.dataIndex || col?.key;
              // @ts-ignore
              const title = typeof col.title === 'function' ? col.title() : col.title;
              return (<Col style={{  whiteSpace: 'nowrap', overflow: 'hidden' }} span={defaultColumns?.length > 4 ? 6 : ''}><Checkbox value={val} disabled={columns?.length === 1 && (val === columns?.[0]?.dataIndex || val === columns?.[0]?.key)}>{title}</Checkbox></Col>)
            })
          }
        </Row>
      </Checkbox.Group>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/table/ColModelMenu.tsx